<div class="product-card"
     (click)="changeShowDescription()"
>
  <div class="libraryItem-card-image">

    <ng-template #noImageFound>
      <img src="../assets/not_found.png" class="image-not-found"/>
    </ng-template>


    <div *ngIf="imageLink; else noImageFound" class="image-wrapper">
      <image [imageLink]="imageLink"></image>
    </div>
  </div>

  <div class="libraryItem-card-info">
    <div class="libraryItem-card-name">{{libraryItem.name}}</div>
    <div class="libraryItem-card-author">{{libraryItem.author}}</div>


  </div>

  <div *ngIf="showDEscription && libraryItem.description" [@fadeSlide] class="description">
    {{libraryItem.description}}
  </div>
  <button mat-button class="main-button to-cart "
          (click)="addToBooking()"
          [disabled]="libraryItem.availability == 'booked' || inBookingCart"
  >
    <span *ngIf="libraryItem.availability == 'available'">Забронировать</span>
    <span *ngIf="libraryItem.availability == 'booked'">На руках</span>
  </button>
</div>


